<template>
  <div v-if="tipoPlano" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes do Tipo de Plano</h4>
      <router-link to="/cadastros/tipos-planos">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <!-- Seção 1 -->
      <FormSection title="">
        <p><strong>Nome:</strong> {{ tipoPlano.nome || 'Não informado' }}</p>
        <p><strong>Duração:</strong> {{ mapDuracao(tipoPlano?.duracao) || 'Não informado' }}</p>
        <p><strong>Ativo:</strong> {{ verificarAtivo(tipoPlano?.ativo) }}</p>
      </FormSection>

      <!-- Seção 2 -->
      <FormSection title="">
        <p><strong>Descrição:</strong> {{ tipoPlano.descricao || 'Não informado' }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";
// import LoadingSpinner from "@/components/Layout/LoadingSpinner.vue"; // ajuste se for global

export default {
  components: { FormSection },
  data() {
    return {
      tipoPlano: null,
    };
  },
  methods: {
    async carregarDetalhesTipoPlano() {
      try {
        const { data } = await axios.get(`/cadastros/tipos-planos/${this.$route.params.id}`);
        this.tipoPlano = data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes do tipo de plano:", error);
      }
    },

    verificarAtivo(valor) {
      if (valor === undefined || valor === null) return "Não informado";
      return valor ? "Ativo" : "Inativo";
    },

    mapDuracao(d) {
      if (!d || Number(d) <= 0) return "Não informado";

      const labels = {
        1: "Diário",
        7: "Semanal",
        14: "Quinzenal",
        30: "Mensal",
        60: "Bimestral",
        90: "Trimestral",
        120: "Quadrimestral",
        180: "Semestral",
        365: "Anual",
      };
      if (labels[d]) return labels[d];

      // conversão “inteligente” para rótulos amigáveis
      if (d % 365 === 0) return `${d / 365} anos`;
      if (d % 30 === 0)  return `${d / 30} meses`;
      if (d % 7 === 0)   return `${d / 7} semanas`;
      return `${d} dias`;
    },
  },
  mounted() {
    this.carregarDetalhesTipoPlano();
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}
.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}
.form-content {
  margin-top: 1.5rem;
}
button.btn-sm {
  padding: 6px 12px;
}
</style>
